import React, { useState } from "react";
import RoadwayPhoto1 from "../../images/services/roadway.webp";
import RoadwayPhoto2 from "../../images/services/round.jpg";
import RoadwayPhoto3 from "../../images/services/DJI_0105.jpg";
import { FaMapMarkedAlt, FaClock } from "react-icons/fa";
import "./ServiceDetailStyles.css";

function RoadwayConstruction() {
  const slides = [RoadwayPhoto1, RoadwayPhoto2, RoadwayPhoto3];
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Roadway Construction</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Services" href="/services">
                      <i className="fa fa-house" /> &nbsp; Services
                    </a>
                  </span>
                  <span>Roadway Construction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <section className="brw-service-detail brw-service-detail--roadway">
        <div className="container">
          <div className="row brw-service-detail__layout">
            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="brw-service-detail__sidebar">
                <h4>Our Services</h4>
                <ul className="brw-service-detail__service-list">
                  <li>
                    <a href="/undergroundUtilities">Underground Utilities</a>
                  </li>
                  <li>
                    <a href="/earthwork">Earthwork</a>
                  </li>
                  <li>
                    <a href="/pavingStriping">Paving & Striping</a>
                  </li>
                  <li className="active">
                    <a href="/roadwayConstruction">Roadway Construction</a>
                  </li>
                  <li>
                    <a href="/segmentedRetainingWalls">
                      Segmented Retaining Walls
                    </a>
                  </li>
                  <li>
                    <a href="/concrete">Concrete</a>
                  </li>
                </ul>

                <div className="brw-service-detail__info-card">
                  <FaMapMarkedAlt />
                  <h5>Service Area</h5>
                  <p>
                    Central Florida & Surrounding Areas
                  </p>
                </div>

                <div className="brw-service-detail__info-card">
                  <FaClock />
                  <h5>Office Hours</h5>
                  <p>
                    Mon–Fri: 8:00 AM – 5:00 PM
                  </p>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-8">
              <div className="brw-service-detail__showcase">
                {/* SLIDER */}
                <div className="brw-service-detail__media">
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--prev"
                    onClick={prevSlide}
                    aria-label="Previous Slide"
                  >
                    ‹
                  </button>
                  <img
                    src={slides[current]}
                    alt="Roadway Slide"
                    className="brw-service-detail__image"
                  />
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--next"
                    onClick={nextSlide}
                    aria-label="Next Slide"
                  >
                    ›
                  </button>
                </div>

                <h4>Professional Roadway Construction</h4>
                <p>
                  BRW Contracting has decades of experience in roadway
                  construction, providing state-of-the-art solutions for
                  municipalities, commercial, and industrial projects. Our
                  attention to detail, expert equipment, and skilled workforce
                  guarantee projects completed on time, on budget, and with the
                  highest quality standards.
                </p>
                <p>
                  From layout and design to final paving, we ensure every
                  roadway is built to last while meeting all client
                  specifications.
                </p>
                <div className="brw-service-detail__chips">
                  <span>Roadway layout</span>
                  <span>Municipal roads</span>
                  <span>Final paving</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default RoadwayConstruction;
